// @flow
import type { ERROR_TYPE } from './common';

export type REPORT_TYPE = {
  header: Array<string>,
  raw_data: Array<Object>,
  rows: Array<string>
};

export type SET_REPORT_TYPE = {
  type: 'SET_REPORT',
  payload: {
    key: string,
  },
};
export const SET_REPORT = 'SET_REPORT';

export type START_FETCHING_REPORT_TYPE = {
  type: 'START_FETCHING_REPORT',
  payload: {
    key: string,
    date_range: Array<string>,
    fromElement: number,
  },
};
export const START_FETCHING_REPORT = 'START_FETCHING_REPORT';

export type REPORT_FETCH_SUCCEEDED_TYPE = {
  type: 'REPORT_FETCH_SUCCEEDED',
  payload: REPORT_TYPE,
};
export const REPORT_FETCH_SUCCEEDED = 'REPORT_FETCH_SUCCEEDED';

export type REPORT_FETCH_FAILED_TYPE = {
  type: 'REPORT_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const REPORT_FETCH_FAILED = 'REPORT_FETCH_FAILED';


export type REPORT_ACTION_TYPE =
  | START_FETCHING_REPORT_TYPE
  | REPORT_FETCH_SUCCEEDED_TYPE
  | REPORT_FETCH_FAILED_TYPE
  | SET_REPORT_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/reports.js